
import React, { useState, useRef, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef(null);

  // Media gallery with photos and videos
  const mediaItems = [
    {
      type: 'image',
      src: '/homep.jpeg', // Replace with your new image filename
      title: 'SK Dienstleistungen',
      description: 'Hausmeisterservice'
    }
  ];

  const currentMedia = mediaItems[currentMediaIndex];

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        {currentMedia.type === 'video' ? (
          <video 
            ref={videoRef}
            className="hero-bg-media"
            poster={currentMedia.poster}
            onPlay={() => setIsVideoPlaying(true)}
            onPause={() => setIsVideoPlaying(false)}
            muted
            loop
          >
            <source src={currentMedia.src} type="video/mp4" />
          </video>
        ) : (
          <img 
            src={currentMedia.src} 
            alt={currentMedia.title}
            className="hero-bg-media"
          />
        )}
        
        {/* Video play overlay */}
        {currentMedia.type === 'video' && !isVideoPlaying && (
          <div className="video-play-overlay" onClick={playVideo}>
            <button className="play-button">
              <i className="fas fa-play"></i>
            </button>
          </div>
        )}

        {/* Text Overlay */}
        <div className="hero-text-overlay">
          <h1 className="hero-main-text">SK DIENSTLEISTUNGEN</h1>
          <h2 className="hero-sub-text">HAUSMEISTERSERVICE</h2>
          <h3 className="hero-description">PFLEGE RUND UM DAS MEHRFAMILIENHAUS UND FIRMENGELÄNDE</h3>
        </div>

      </div>
    </section>
  );
};

export default Hero;